

import React, { useState } from "react";
import GetYears from "../../Dropdowns/getYears";
import NoofLoginInterfaxe from "./NoofLoginInterfaxe";
import GetMonths from "../../Dropdowns/getMonths";
import GetDistrictsRoleBased from "../../Dropdowns/getDistrictsRoleBased";
import GetAfsoRoleBased from  "../../Dropdowns/getAfsoRoleBased";


const NoOfLogindaysInt = ({ heading }) => {
  const [selectedDist, setSelectedDist] = useState("");
  const [selectedAfso, setSelectedAfso] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingAfso, setLoadingAfso] = useState(false);
  const [loadingFpsId, setLoadingFpsId] = useState(false);
  const [renderContent, setRenderContent] = useState(null);

  const handleDistrictChange = (dist_code) => {
    setSelectedDist(dist_code);
    setSelectedAfso(""); // Reset AFSO and FPS when district changes
  };

  const handleAfsoChange = (afso_code) => {
    setSelectedAfso(afso_code);
  };

  const handleSubmit = () => {
    const month = document.getElementById("month")?.value;
    const year = document.getElementById("year")?.value;

    if (!month || month === "0" || month.trim() === "") {
      alert("Please select a valid Month.");
      return;
    }
    if (!year || year === "0" || year.trim() === "") {
      alert(" Please select a valid Year.");
      return;
    }
    
    setRenderContent(null);
    setTimeout(() => {
      setRenderContent(
        <NoofLoginInterfaxe
          month={month}
          year={year}
          dist_code={selectedDist}
          //fps_id={fps_id}
          afso_code={selectedAfso}
          heading={heading}
        />
      );
    }, 0);
  };

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table width="70%">
            <thead>
              <tr className="tableheader">
                <th colSpan={10}>Login Days (V/s) SchemeWise Sales</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Month</td>
                <td>
                  <GetMonths onLoadingChange={setLoading} />
                </td>

                <td>Year</td>
                <td>
                  <GetYears onLoadingChange={setLoading} />
                </td>

                <td>District</td>
                <td>
                  <GetDistrictsRoleBased
                    onLoadingChange={setLoadingDistricts}
                    onChange={handleDistrictChange}
                  />
                </td>

                <td>AFSO</td>
                <td>
                  {selectedDist ? (
                    <GetAfsoRoleBased
                      dist_code={selectedDist}
                      onLoadingChange={setLoadingAfso}
                      onChange={handleAfsoChange}
                    />
                  ) : (
                    <select disabled>
                      <option value="">select</option>
                    </select>
                  )}
                </td>

                {/* <td>FPS</td>
                <td>
                  {selectedAfso ? (
                    <GetFpssId
                      dist_code={selectedDist}
                      afso_code={selectedAfso}
                      onLoadingChange={setLoadingFpsId}
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td> */}
              </tr>

              <tr>
                <td colSpan={10} align="center">
                  <button
                    onClick={handleSubmit}
                    className="button button2"
                    disabled={loading}
                  >
                    Submit
                  </button>
                  <button
                    onClick={() => window.history.back()}
                    className="button button2"
                  >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />
        <div id="details1">{renderContent}</div>
      </div>
    </div>
  );
};

export default NoOfLogindaysInt; 






